import { render } from "./account.vue?vue&type=template&id=5a77b501&scoped=true"
import script from "./account.vue?vue&type=script&scope=true&lang=js"
export * from "./account.vue?vue&type=script&scope=true&lang=js"

import "./account.vue?vue&type=style&index=0&id=5a77b501&scoped=true&lang=css"

import exportComponent from "D:\\code\\dapp-wallet\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a77b501"]])

export default __exports__